export type Country = {
  fr: string;
  en: string;
};

export type Countries = { [isoCode: string]: Country };

export const COUNTRIES: Countries = {
  AF: { fr: 'Afghanistan', en: 'Afghanistan' },
  ZA: { fr: 'Afrique du Sud', en: 'South Africa' },
  AL: { fr: 'Albanie', en: 'Albania' },
  DZ: { fr: 'Algérie', en: 'Algeria' },
  DE: { fr: 'Allemagne', en: 'Germany' },
  AD: { fr: 'Andorre', en: 'Andorra' },
  AO: { fr: 'Angola', en: 'Angola' },
  AI: { fr: 'Anguilla', en: 'Anguilla' },
  AQ: { fr: 'Antarctique', en: 'Antarctica' },
  AG: { fr: 'Antigua-et-Barbuda', en: 'Antigua & Barbuda' },
  SA: { fr: 'Arabie saoudite', en: 'Saudi Arabia' },
  AR: { fr: 'Argentine', en: 'Argentina' },
  AM: { fr: 'Arménie', en: 'Armenia' },
  AW: { fr: 'Aruba', en: 'Aruba' },
  AU: { fr: 'Australie', en: 'Australia' },
  AT: { fr: 'Autriche', en: 'Austria' },
  AZ: { fr: 'Azerbaïdjan', en: 'Azerbaijan' },
  BS: { fr: 'Bahamas', en: 'Bahamas' },
  BH: { fr: 'Bahreïn', en: 'Bahrain' },
  BD: { fr: 'Bangladesh', en: 'Bangladesh' },
  BB: { fr: 'Barbade', en: 'Barbados' },
  BE: { fr: 'Belgique', en: 'Belgium' },
  BZ: { fr: 'Belize', en: 'Belize' },
  BJ: { fr: 'Bénin', en: 'Benin' },
  BM: { fr: 'Bermudes', en: 'Bermuda' },
  BT: { fr: 'Bhoutan', en: 'Bhutan' },
  BY: { fr: 'Biélorussie', en: 'Belarus' },
  BO: { fr: 'Bolivie', en: 'Bolivia' },
  BA: { fr: 'Bosnie-Herzégovine', en: 'Bosnia & Herzegovina' },
  BW: { fr: 'Botswana', en: 'Botswana' },
  BR: { fr: 'Brésil', en: 'Brazil' },
  BN: { fr: 'Brunéi Darussalam', en: 'Brunei' },
  BG: { fr: 'Bulgarie', en: 'Bulgaria' },
  BF: { fr: 'Burkina Faso', en: 'Burkina Faso' },
  BI: { fr: 'Burundi', en: 'Burundi' },
  KH: { fr: 'Cambodge', en: 'Cambodia' },
  CM: { fr: 'Cameroun', en: 'Cameroon' },
  CA: { fr: 'Canada', en: 'Canada' },
  CV: { fr: 'Cap-Vert', en: 'Cape Verde' },
  CL: { fr: 'Chili', en: 'Chile' },
  CN: { fr: 'Chine', en: 'China' },
  CY: { fr: 'Chypre', en: 'Cyprus' },
  CO: { fr: 'Colombie', en: 'Colombia' },
  KM: { fr: 'Comores', en: 'Comoros' },
  CG: { fr: 'Congo-Brazzaville', en: 'Congo - Brazzaville' },
  CD: { fr: 'Congo-Kinshasa', en: 'Congo - Kinshasa' },
  KP: { fr: 'Corée du Nord', en: 'North Korea' },
  KR: { fr: 'Corée du Sud', en: 'South Korea' },
  CR: { fr: 'Costa Rica', en: 'Costa Rica' },
  CI: { fr: "Côte d'Ivoire", en: "Côte d'Ivoire" },
  HR: { fr: 'Croatie', en: 'Croatia' },
  CU: { fr: 'Cuba', en: 'Cuba' },
  CW: { fr: 'Curaçao', en: 'Curaçao' },
  DK: { fr: 'Danemark', en: 'Denmark' },
  DJ: { fr: 'Djibouti', en: 'Djibouti' },
  DM: { fr: 'Dominique', en: 'Dominica' },
  EG: { fr: 'Égypte', en: 'Egypt' },
  AE: { fr: 'Émirats arabes unis', en: 'United Arab Emirates' },
  EC: { fr: 'Équateur', en: 'Ecuador' },
  ER: { fr: 'Érythrée', en: 'Eritrea' },
  ES: { fr: 'Espagne', en: 'Spain' },
  EE: { fr: 'Estonie', en: 'Estonia' },
  SZ: { fr: 'Eswatini', en: 'Eswatini' },
  VA: { fr: 'État de la Cité du Vatican', en: 'Vatican City' },
  FM: { fr: 'États fédérés de Micronésie', en: 'Micronesia' },
  US: { fr: 'États-Unis', en: 'United States' },
  ET: { fr: 'Éthiopie', en: 'Ethiopia' },
  FJ: { fr: 'Fidji', en: 'Fiji' },
  FI: { fr: 'Finlande', en: 'Finland' },
  FR: { fr: 'France', en: 'France' },
  GA: { fr: 'Gabon', en: 'Gabon' },
  GM: { fr: 'Gambie', en: 'Gambia' },
  GE: { fr: 'Géorgie', en: 'Georgia' },
  GS: {
    fr: 'Géorgie du Sud et îles Sandwich du Sud',
    en: 'South Georgia & South Sandwich Islands',
  },
  GH: { fr: 'Ghana', en: 'Ghana' },
  GI: { fr: 'Gibraltar', en: 'Gibraltar' },
  GR: { fr: 'Grèce', en: 'Greece' },
  GD: { fr: 'Grenade', en: 'Grenada' },
  GL: { fr: 'Groenland', en: 'Greenland' },
  GP: { fr: 'Guadeloupe', en: 'Guadeloupe' },
  GU: { fr: 'Guam', en: 'Guam' },
  GT: { fr: 'Guatemala', en: 'Guatemala' },
  GG: { fr: 'Guernesey', en: 'Guernsey' },
  GN: { fr: 'Guinée', en: 'Guinea' },
  GQ: { fr: 'Guinée équatoriale', en: 'Equatorial Guinea' },
  GW: { fr: 'Guinée-Bissau', en: 'Guinea-Bissau' },
  GY: { fr: 'Guyana', en: 'Guyana' },
  GF: { fr: 'Guyane française', en: 'French Guiana' },
  HT: { fr: 'Haïti', en: 'Haiti' },
  HN: { fr: 'Honduras', en: 'Honduras' },
  HU: { fr: 'Hongrie', en: 'Hungary' },
  BV: { fr: 'Île Bouvet', en: 'Bouvet Island' },
  CX: { fr: 'Île Christmas', en: 'Christmas Island' },
  IM: { fr: 'Île de Man', en: 'Isle of Man' },
  NF: { fr: 'Île Norfolk', en: 'Norfolk Island' },
  AX: { fr: 'Îles Åland', en: 'Åland Islands' },
  KY: { fr: 'Îles Caïmans', en: 'Cayman Islands' },
  CC: { fr: 'Îles Cocos', en: 'Cocos (Keeling) Islands' },
  CK: { fr: 'Îles Cook', en: 'Cook Islands' },
  FO: { fr: 'Îles Féroé', en: 'Faroe Islands' },
  HM: { fr: 'Îles Heard et McDonald', en: 'Heard & McDonald Islands' },
  FK: { fr: 'Îles Malouines', en: 'Falkland Islands' },
  MP: { fr: 'Îles Mariannes du Nord', en: 'Northern Mariana Islands' },
  MH: { fr: 'Îles Marshall', en: 'Marshall Islands' },
  UM: {
    fr: 'Îles mineures éloignées des États-Unis',
    en: 'U.S. Outlying Islands',
  },
  PN: { fr: 'Îles Pitcairn', en: 'Pitcairn Islands' },
  SB: { fr: 'Îles Salomon', en: 'Solomon Islands' },
  TC: { fr: 'Îles Turques-et-Caïques', en: 'Turks & Caicos Islands' },
  VG: { fr: 'Îles Vierges britanniques', en: 'British Virgin Islands' },
  VI: { fr: 'Îles Vierges des États-Unis', en: 'U.S. Virgin Islands' },
  IN: { fr: 'Inde', en: 'India' },
  ID: { fr: 'Indonésie', en: 'Indonesia' },
  IQ: { fr: 'Irak', en: 'Iraq' },
  IR: { fr: 'Iran', en: 'Iran' },
  IE: { fr: 'Irlande', en: 'Ireland' },
  IS: { fr: 'Islande', en: 'Iceland' },
  IL: { fr: 'Israël', en: 'Israel' },
  IT: { fr: 'Italie', en: 'Italy' },
  JM: { fr: 'Jamaïque', en: 'Jamaica' },
  JP: { fr: 'Japon', en: 'Japan' },
  JE: { fr: 'Jersey', en: 'Jersey' },
  JO: { fr: 'Jordanie', en: 'Jordan' },
  KZ: { fr: 'Kazakhstan', en: 'Kazakhstan' },
  KE: { fr: 'Kenya', en: 'Kenya' },
  KG: { fr: 'Kirghizistan', en: 'Kyrgyzstan' },
  KI: { fr: 'Kiribati', en: 'Kiribati' },
  XK: { fr: 'Kosovo', en: 'Kosovo' },
  KW: { fr: 'Koweït', en: 'Kuwait' },
  RE: { fr: 'La Réunion', en: 'Réunion' },
  LA: { fr: 'Laos', en: 'Laos' },
  LS: { fr: 'Lesotho', en: 'Lesotho' },
  LV: { fr: 'Lettonie', en: 'Latvia' },
  LB: { fr: 'Liban', en: 'Lebanon' },
  LR: { fr: 'Libéria', en: 'Liberia' },
  LY: { fr: 'Libye', en: 'Libya' },
  LI: { fr: 'Liechtenstein', en: 'Liechtenstein' },
  LT: { fr: 'Lituanie', en: 'Lithuania' },
  LU: { fr: 'Luxembourg', en: 'Luxembourg' },
  MK: { fr: 'Macédoine du Nord', en: 'North Macedonia' },
  MG: { fr: 'Madagascar', en: 'Madagascar' },
  MY: { fr: 'Malaisie', en: 'Malaysia' },
  MW: { fr: 'Malawi', en: 'Malawi' },
  MV: { fr: 'Maldives', en: 'Maldives' },
  ML: { fr: 'Mali', en: 'Mali' },
  MT: { fr: 'Malte', en: 'Malta' },
  MA: { fr: 'Maroc', en: 'Morocco' },
  MQ: { fr: 'Martinique', en: 'Martinique' },
  MU: { fr: 'Maurice', en: 'Mauritius' },
  MR: { fr: 'Mauritanie', en: 'Mauritania' },
  YT: { fr: 'Mayotte', en: 'Mayotte' },
  MX: { fr: 'Mexique', en: 'Mexico' },
  MD: { fr: 'Moldavie', en: 'Moldova' },
  MC: { fr: 'Monaco', en: 'Monaco' },
  MN: { fr: 'Mongolie', en: 'Mongolia' },
  ME: { fr: 'Monténégro', en: 'Montenegro' },
  MS: { fr: 'Montserrat', en: 'Montserrat' },
  MZ: { fr: 'Mozambique', en: 'Mozambique' },
  MM: { fr: 'Myanmar (Birmanie)', en: 'Myanmar (Burma)' },
  NA: { fr: 'Namibie', en: 'Namibia' },
  NR: { fr: 'Nauru', en: 'Nauru' },
  NP: { fr: 'Népal', en: 'Nepal' },
  NI: { fr: 'Nicaragua', en: 'Nicaragua' },
  NE: { fr: 'Niger', en: 'Niger' },
  NG: { fr: 'Nigeria', en: 'Nigeria' },
  NU: { fr: 'Niue', en: 'Niue' },
  NO: { fr: 'Norvège', en: 'Norway' },
  NC: { fr: 'Nouvelle-Calédonie', en: 'New Caledonia' },
  NZ: { fr: 'Nouvelle-Zélande', en: 'New Zealand' },
  OM: { fr: 'Oman', en: 'Oman' },
  UG: { fr: 'Ouganda', en: 'Uganda' },
  UZ: { fr: 'Ouzbékistan', en: 'Uzbekistan' },
  PK: { fr: 'Pakistan', en: 'Pakistan' },
  PW: { fr: 'Palaos', en: 'Palau' },
  PS: { fr: 'Palestine', en: 'Palestine' },
  PA: { fr: 'Panama', en: 'Panama' },
  PG: { fr: 'Papouasie-Nouvelle-Guinée', en: 'Papua New Guinea' },
  PY: { fr: 'Paraguay', en: 'Paraguay' },
  NL: { fr: 'Pays-Bas', en: 'Netherlands' },
  PE: { fr: 'Pérou', en: 'Peru' },
  PH: { fr: 'Philippines', en: 'Philippines' },
  PL: { fr: 'Pologne', en: 'Poland' },
  PF: { fr: 'Polynésie française', en: 'French Polynesia' },
  PR: { fr: 'Porto Rico', en: 'Puerto Rico' },
  PT: { fr: 'Portugal', en: 'Portugal' },
  QA: { fr: 'Qatar', en: 'Qatar' },
  HK: { fr: 'R.A.S. chinoise de Hong Kong', en: 'Hong Kong SAR China' },
  MO: { fr: 'R.A.S. chinoise de Macao', en: 'Macao SAR China' },
  CF: { fr: 'République centrafricaine', en: 'Central African Republic' },
  DO: { fr: 'République dominicaine', en: 'Dominican Republic' },
  RO: { fr: 'Roumanie', en: 'Romania' },
  GB: { fr: 'Royaume-Uni', en: 'United Kingdom' },
  RU: { fr: 'Russie', en: 'Russia' },
  RW: { fr: 'Rwanda', en: 'Rwanda' },
  EH: { fr: 'Sahara occidental', en: 'Western Sahara' },
  BL: { fr: 'Saint-Barthélémy', en: 'St. Barthélemy' },
  KN: { fr: 'Saint-Christophe-et-Niévès', en: 'St. Kitts & Nevis' },
  SM: { fr: 'Saint-Marin', en: 'San Marino' },
  MF: {
    fr: 'Saint-Martin (partie française)',
    en: 'St. Martin (French part)',
  },
  SX: {
    fr: 'Saint-Martin (partie néerlandaise)',
    en: 'St. Martin (Dutch part)',
  },
  PM: { fr: 'Saint-Pierre-et-Miquelon', en: 'St. Pierre & Miquelon' },
  VC: {
    fr: 'Saint-Vincent-et-les-Grenadines',
    en: 'St. Vincent & Grenadines',
  },
  SH: { fr: 'Sainte-Hélène', en: 'St. Helena' },
  LC: { fr: 'Sainte-Lucie', en: 'St. Lucia' },
  WS: { fr: 'Samoa', en: 'Samoa' },
  AS: { fr: 'Samoa américaines', en: 'American Samoa' },
  ST: { fr: 'Sao Tomé-et-Principe', en: 'São Tomé & Príncipe' },
  SN: { fr: 'Sénégal', en: 'Senegal' },
  RS: { fr: 'Serbie', en: 'Serbia' },
  SC: { fr: 'Seychelles', en: 'Seychelles' },
  SL: { fr: 'Sierra Leone', en: 'Sierra Leone' },
  SG: { fr: 'Singapour', en: 'Singapore' },
  SK: { fr: 'Slovaquie', en: 'Slovakia' },
  SI: { fr: 'Slovénie', en: 'Slovenia' },
  SO: { fr: 'Somalie', en: 'Somalia' },
  SD: { fr: 'Soudan', en: 'Sudan' },
  SS: { fr: 'Soudan du Sud', en: 'South Sudan' },
  LK: { fr: 'Sri Lanka', en: 'Sri Lanka' },
  SE: { fr: 'Suède', en: 'Sweden' },
  CH: { fr: 'Suisse', en: 'Switzerland' },
  SR: { fr: 'Suriname', en: 'Suriname' },
  SY: { fr: 'Syrie', en: 'Syria' },
  TJ: { fr: 'Tadjikistan', en: 'Tajikistan' },
  TW: { fr: 'Taïwan', en: 'Taiwan' },
  TZ: { fr: 'Tanzanie', en: 'Tanzania' },
  TD: { fr: 'Tchad', en: 'Chad' },
  CZ: { fr: 'Tchéquie', en: 'Czech Republic' },
  IO: {
    fr: 'Territoire britannique de l’océan Indien',
    en: 'British Indian Ocean Territory',
  },
  TH: { fr: 'Thaïlande', en: 'Thailand' },
  TL: { fr: 'Timor oriental', en: 'Timor-Leste' },
  TG: { fr: 'Togo', en: 'Togo' },
  TK: { fr: 'Tokelau', en: 'Tokelau' },
  TO: { fr: 'Tonga', en: 'Tonga' },
  TT: { fr: 'Trinité-et-Tobago', en: 'Trinidad & Tobago' },
  TN: { fr: 'Tunisie', en: 'Tunisia' },
  TM: { fr: 'Turkménistan', en: 'Turkmenistan' },
  TR: { fr: 'Turquie', en: 'Turkey' },
  TV: { fr: 'Tuvalu', en: 'Tuvalu' },
  UA: { fr: 'Ukraine', en: 'Ukraine' },
  UY: { fr: 'Uruguay', en: 'Uruguay' },
  VU: { fr: 'Vanuatu', en: 'Vanuatu' },
  VE: { fr: 'Venezuela', en: 'Venezuela' },
  VN: { fr: 'Vietnam', en: 'Vietnam' },
  WF: { fr: 'Wallis-et-Futuna', en: 'Wallis & Futuna' },
  YE: { fr: 'Yémen', en: 'Yemen' },
  ZM: { fr: 'Zambie', en: 'Zambia' },
  ZW: { fr: 'Zimbabwe', en: 'Zimbabwe' },
};

// Countries of residence LTY accepts at registration and profile update
export const RESIDENCE_COUNTRIES = ['CH', 'DE', 'AT', 'FR', 'IT', 'LI'];

export const COUNTRY_CODES = {
  '880': ['BD'],
  '32': ['BE'],
  '226': ['BF'],
  '359': ['BG'],
  '387': ['BA'],
  '1-246': ['BB'],
  '681': ['WF'],
  '590': ['BL', 'GP', 'MF'],
  '1-441': ['BM'],
  '673': ['BN'],
  '591': ['BO'],
  '973': ['BH'],
  '257': ['BI'],
  '229': ['BJ'],
  '975': ['BT'],
  '1-876': ['JM'],
  '267': ['BW'],
  '685': ['WS'],
  '599': ['BQ', 'CW', 'SX'],
  '55': ['BR'],
  '1-242': ['BS'],
  '44-1534': ['JE'],
  '375': ['BY'],
  '501': ['BZ'],
  '7': ['RU', 'KZ'],
  '250': ['RW'],
  '381': ['RS'],
  '670': ['TL'],
  '262': ['RE', 'YT'],
  '993': ['TM'],
  '992': ['TJ'],
  '40': ['RO'],
  '690': ['TK'],
  '245': ['GW'],
  '1-671': ['GU'],
  '502': ['GT'],
  '30': ['GR'],
  '240': ['GQ'],
  '81': ['JP'],
  '592': ['GY'],
  '44-1481': ['GG'],
  '594': ['GF'],
  '995': ['GE'],
  '1-473': ['GD'],
  '44': ['GB'],
  '241': ['GA'],
  '503': ['SV'],
  '224': ['GN'],
  '220': ['GM'],
  '299': ['GL'],
  '350': ['GI'],
  '233': ['GH'],
  '968': ['OM'],
  '216': ['TN'],
  '962': ['JO'],
  '385': ['HR'],
  '509': ['HT'],
  '36': ['HU'],
  '852': ['HK'],
  '504': ['HN'],
  '58': ['VE'],
  '1-787': ['PR'],
  '1-939': ['PR'],
  '970': ['PS'],
  '680': ['PW'],
  '351': ['PT'],
  '47': ['SJ', 'NO'],
  '595': ['PY'],
  '964': ['IQ'],
  '507': ['PA'],
  '689': ['PF'],
  '675': ['PG'],
  '51': ['PE'],
  '92': ['PK'],
  '63': ['PH'],
  '870': ['PN'],
  '48': ['PL'],
  '508': ['PM'],
  '260': ['ZM'],
  '212': ['EH', 'MA'],
  '372': ['EE'],
  '20': ['EG'],
  '27': ['ZA'],
  '593': ['EC'],
  '39': ['IT'],
  '84': ['VN'],
  '677': ['SB'],
  '251': ['ET'],
  '252': ['SO'],
  '263': ['ZW'],
  '966': ['SA'],
  '34': ['ES'],
  '291': ['ER'],
  '382': ['ME'],
  '373': ['MD'],
  '261': ['MG'],
  '377': ['MC'],
  '998': ['UZ'],
  '95': ['MM'],
  '223': ['ML'],
  '853': ['MO'],
  '976': ['MN'],
  '692': ['MH'],
  '389': ['MK'],
  '230': ['MU'],
  '356': ['MT'],
  '265': ['MW'],
  '960': ['MV'],
  '596': ['MQ'],
  '1-670': ['MP'],
  '1-664': ['MS'],
  '222': ['MR'],
  '44-1624': ['IM'],
  '256': ['UG'],
  '255': ['TZ'],
  '60': ['MY'],
  '52': ['MX'],
  '972': ['IL'],
  '33': ['FR'],
  '246': ['IO'],
  '290': ['SH'],
  '358': ['FI'],
  '679': ['FJ'],
  '500': ['FK'],
  '691': ['FM'],
  '298': ['FO'],
  '505': ['NI'],
  '31': ['NL'],
  '264': ['NA'],
  '678': ['VU'],
  '687': ['NC'],
  '227': ['NE'],
  '672': ['NF'],
  '234': ['NG'],
  '64': ['NZ'],
  '977': ['NP'],
  '674': ['NR'],
  '683': ['NU'],
  '682': ['CK'],
  '225': ['CI'],
  '41': ['CH'],
  '57': ['CO'],
  '86': ['CN'],
  '237': ['CM'],
  '56': ['CL'],
  '61': ['CC', 'CX', 'AU'],
  '1': ['CA', 'UM', 'US'],
  '242': ['CG'],
  '236': ['CF'],
  '243': ['CD'],
  '420': ['CZ'],
  '357': ['CY'],
  '506': ['CR'],
  '238': ['CV'],
  '53': ['CU'],
  '268': ['SZ'],
  '963': ['SY'],
  '996': ['KG'],
  '254': ['KE'],
  '211': ['SS'],
  '597': ['SR'],
  '686': ['KI'],
  '855': ['KH'],
  '1-869': ['KN'],
  '269': ['KM'],
  '239': ['ST'],
  '421': ['SK'],
  '82': ['KR'],
  '386': ['SI'],
  '850': ['KP'],
  '965': ['KW'],
  '221': ['SN'],
  '378': ['SM'],
  '232': ['SL'],
  '248': ['SC'],
  '65': ['SG'],
  '46': ['SE'],
  '249': ['SD'],
  '1-809': ['DO'],
  '1-829': ['DO'],
  '1-767': ['DM'],
  '253': ['DJ'],
  '45': ['DK'],
  '1-284': ['VG'],
  '49': ['DE'],
  '967': ['YE'],
  '213': ['DZ'],
  '598': ['UY'],
  '961': ['LB'],
  '1-758': ['LC'],
  '856': ['LA'],
  '688': ['TV'],
  '886': ['TW'],
  '1-868': ['TT'],
  '90': ['TR'],
  '94': ['LK'],
  '423': ['LI'],
  '371': ['LV'],
  '676': ['TO'],
  '370': ['LT'],
  '352': ['LU'],
  '231': ['LR'],
  '266': ['LS'],
  '66': ['TH'],
  '228': ['TG'],
  '235': ['TD'],
  '1-649': ['TC'],
  '218': ['LY'],
  '379': ['VA'],
  '1-784': ['VC'],
  '971': ['AE'],
  '376': ['AD'],
  '1-268': ['AG'],
  '93': ['AF'],
  '1-264': ['AI'],
  '1-340': ['VI'],
  '354': ['IS'],
  '98': ['IR'],
  '374': ['AM'],
  '355': ['AL'],
  '244': ['AO'],
  '54': ['AR'],
  '43': ['AT'],
  '297': ['AW'],
  '91': ['IN'],
  '358-18': ['AX'],
  '994': ['AZ'],
  '353': ['IE'],
  '62': ['ID'],
  '380': ['UA'],
  '974': ['QA'],
  '258': ['MZ'],
  '383': ['XK'],
};

export const getCountryName = (countryCode: string, languageCode: string) => {
  if (COUNTRIES[countryCode]) {
    return COUNTRIES[countryCode][languageCode as keyof Country] ?? COUNTRIES[countryCode].fr;
  }
  return countryCode;
};
